import { render, staticRenderFns } from "./resourceStoreTypeTree.vue?vue&type=template&id=9fc65d18&scoped=true"
import script from "./resourceStoreTypeTree.vue?vue&type=script&lang=js"
export * from "./resourceStoreTypeTree.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreTypeTree.vue?vue&type=style&index=0&id=9fc65d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc65d18",
  null
  
)

export default component.exports